import ActionPanel from '@/components/ActionPanel';
import PageContent from '@/components/PageContent';
import { ActivityInfo } from '@/models/activity-info.model';
import { ClubEventStatusEnum, ClubEventVisibilityEnum, UpsertRunningClubEvent } from '@/models/running-club-event.model';
import { pathToGeoJson } from '@/utils/map';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PanelGroup, useToaster } from 'rsuite';



interface ActivityActionsProps{
    formObject?: ActivityInfo;
};

const ActivityActions: React.FC<ActivityActionsProps> = ({formObject}) => {

  const nav = useNavigate();
  const toaster = useToaster();

  const handleClickCreateClubEvent = () => {
    if(!formObject || !formObject.route?.length) return;
    const state : {initValue: UpsertRunningClubEvent} = {initValue: {
      startTime: formObject.startTime,
      endTime: new Date(formObject.startTime.getTime() + formObject.duration * 1000),
      jsonPath: pathToGeoJson(formObject.route),
      visibility: ClubEventVisibilityEnum.Public,
      status: ClubEventStatusEnum.Draft,
    }};
    nav('/running-clubs/events/new', {state});
  };

  return (
      <PageContent>
          <PanelGroup>
              <ActionPanel
                title='Create Running Club Event'
                description='This action direct you to club event page to create a new running club event based on this activity. If the activity club event already is set or activity has no route, this action will be disabled.'
                onClick={handleClickCreateClubEvent}
                disabled={!formObject?.route?.length || !!formObject.runningClubEventId}
              />
          </PanelGroup>
      </PageContent>
  );
};

export default ActivityActions;
